import Coches from './Coches.js'
import Motos from './Motos.js'

export {Coches, Motos}
